import { Link } from 'react-router-dom';
import bwfLogo from '../assets/bwf_logo.png';
import affiliateLogo from '../assets/affiliate_approved_manufacturer.png';
import teknosLogo from '../assets/teknos_logo_black.png';
import styles from '../styles/PartnersAffiliates.module.css';

const logos = [
  {
    title: 'British Woodworking Federation',
    src: bwfLogo,
    alt: 'British Woodworking Federation logo',
    href: 'https://www.bwf.org.uk/',
  },
  {
    title: 'Affiliate Approved Manufacturer',
    src: affiliateLogo,
    alt: 'Affiliate Approved Manufacturer logo',
    to: '/accoya',
  },
  {
    title: 'Teknos',
    src: teknosLogo,
    alt: 'Teknos logo',
    href: 'https://www.teknos.com/en-GB/',
  },
];

const PartnersAffiliates = () => {
  return (
    <section className={styles.section}>
      <div className="contentWrapper">
        <header className={styles.header}>
          <h2>Partners &amp; Affiliates</h2>
        </header>

        <div className={styles.grid}>
          {logos.map((logo) => (
            logo.to ? (
              <Link key={logo.title} to={logo.to} className={`${styles.card} ${styles.cardLink}`}>
                <h3>{logo.title}</h3>
                <div className={styles.logoWrap}>
                  <img src={logo.src} alt={logo.alt} />
                </div>
              </Link>
            ) : logo.href ? (
              <a
                key={logo.title}
                href={logo.href}
                target="_blank"
                rel="noreferrer"
                className={`${styles.card} ${styles.cardLink}`}
              >
                <h3>{logo.title}</h3>
                <div className={styles.logoWrap}>
                  <img src={logo.src} alt={logo.alt} />
                </div>
              </a>
            ) : (
              <article key={logo.title} className={styles.card}>
                <h3>{logo.title}</h3>
                <div className={styles.logoWrap}>
                  <img src={logo.src} alt={logo.alt} />
                </div>
              </article>
            )
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersAffiliates;
